import { TEXT_HTML_REQUEST_HEADER } from "../../common/store-header-services-constants";
const CONTEXT_LAYER_URL = '/store-header-module/services/contextlayer';
export function getNotificationSuccessTemplate(successCallback, errorCallback) {
  lm.fetch({
    url: CONTEXT_LAYER_URL + '/notification-success',
    method: 'GET',
    credentials: 'same-origin',
    headers: TEXT_HTML_REQUEST_HEADER,
    success: successCallback,
    error: errorCallback
  });
}